<template>
  <div class="learning-path text-center">
    <div class="back">

    </div>
    <div class="container">
      <div class="heading">
        <h3>Learning Path</h3>
      </div>
      <div class="links">
        <div class="row">
          <div class="col-md-4" v-for="(name, index) in pathsNames" :key="index">
            <div class="content">
              <button :ref="name.toUpperCase() + 'minus'" class="minus"
                      @click.prevent="showPathsByName(name.toUpperCase())">+
              </button>
              <button :ref="name.toUpperCase() + 'class'" class="art butback path-show"
                      @click.prevent="showPathsByName(name.toUpperCase())"
                      :value="name.toUpperCase()">
                {{ name }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="fileds" id="collapseExample">
        <div class="row" v-for="(paths, index) in getPathsByName" :key="index">
          <div class="col-md-4 sec pointer"
               @click.prevent="goToPath(path.id)"
               v-for="(path, index2) in pathsByName(paths)" :key="index2"
               :ref="path.name.toUpperCase() + index2">
            <div class="filed"
                 :class="[index === 0 ? 'gray' : index === 1 ? 'green' : 'yellow']">
              <h4>{{ path.name }}</h4>
              <span class="precent">64%</span>
              <p>Level <span v-if="path.level < 10">{{ "0" + path.level }}</span> <span v-else>{{ path.level }}</span>
              </p>
              <div class="progress">
                <div class="progress-bar" style="width: 64%;">
                    <span class="progress-icon ">
                      <span class="dot-prog"></span>
                    </span>

                  <div class="progress-value">64%</div>
                </div>
              </div>
              <span class="dot"></span>
            </div>
          </div>
        </div>
      </div>
      <Team/>
    </div>
  </div>
</template>

<script>
import Team from "@/components/dashboard/Team";

export default {
  components: {Team},
  methods: {
    goToPath(id) {
      this.$router.push('/category' + id)
    },
    pathsByName(name) {
      return this.user.paths
          .filter(path => path.name === name);
    },
    showPathsByName(name) {
      for (let [key, value] of Object.entries(this.$refs)) {
        if (key.startsWith(name)) {
          if (key.endsWith('class')) {
            if ([...value[0].classList].includes('path-show')) {
              value[0].classList.remove('path-show')
            } else {
              value[0].classList.add('path-show')
            }
          } else if (key.endsWith('minus')) {
            if (value[0].innerHTML === '+') {
              value[0].innerHTML = '-';
            } else {
              value[0].innerHTML = '+';
            }
          } else {
            if ([...value[0].classList].includes('hidden')) {
              value[0].classList.remove('hidden')
            } else {
              value[0].classList.add('hidden')
            }
          }
        }
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/userData"];
    },
    pathsNames() {
      return this.$store.getters["auth/pathsNames"];
    },
    getPathsByName() {
      return this.$store.getters["auth/pathsByName"];
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/dashboard/styles.scss";

.pointer {
  cursor: pointer;
}

.hidden {
  display: none;
}

.path-show {
  background: linear-gradient(90deg, rgba(0, 243, 126, 0.5) 0%, rgba(0, 243, 126, 0) 120.44%) !important;
  border: none !important;
}

.learning-path {
  background: #003827;
  position: relative;
  padding: 50px 0 304px 0;

  .back {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0;
    background: linear-gradient(268.79deg, #050505 34.59%, rgba(5, 5, 5, 0) 117.52%);
    border-radius: 0px 287px 0px 0px;
  }

  .heading {
    position: relative;
    margin-bottom: 50px;

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 36px;
      line-height: 107.19%;
      color: #FFFFFF;
    }
  }

  .links {
    padding: 0 320px;
    position: relative;
    margin-bottom: 32px;

    .content {
      position: relative;

      .minus {
        position: absolute;
        width: 17px;
        height: 17px;
        right: -9px;
        top: -8px;
        background: #00F37E;
        color: #FFF;
        border-radius: 50%;
        line-height: 17px;
        padding: 0;
        border: none;
      }

      button {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 98.3%;
        color: #FFFFFF;
        border-radius: 4px;
        text-decoration: none;
        display: inline-block;
        width: 100%;
        padding: 13px 0;
        background: unset;
        border: 10px solid;
        border-image-slice: 1;
        border-width: 1px;
        border-image-source: linear-gradient(to right, #00F37E, #000);
        transition: all 2s ease-in-out;
        //border: none
      }
    }
  }

  .fileds {
    position: relative;

    .sec {
      .gray {
        background: linear-gradient(99.52deg, #E1E1E1 -32.99%, #000000 120.45%);
        border-radius: 15px;
        padding: 28px 32px;
        margin: 12px 0;
        position: relative;

        h4 {
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 107.19%;
          text-align: justify;
          color: #FFFFFF;
        }

        span.precent {
          position: absolute;
          right: 32px;
          top: 28px;
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          font-size: 18px;
          line-height: 107.19%;
          color: #FFFFFF;
        }

        p {
          @extend h4;
          font-weight: lighter;
        }

        .progress {
          height: 3px;
          overflow: visible;
          background: #f0f0f0;
          margin-bottom: 18px;

          .progress-bar {
            position: relative;
            animation: animate-positive 2s;
            overflow: visible;
            background: #00F37E;

            .progress-icon {
              width: 21px;
              height: 21px;
              border-radius: 50%;
              position: absolute;
              top: -10px;
              right: -9px;
              background: unset;
              border: 1px solid #00F37E;

              .dot-prog {
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: #00F37E;
                position: absolute;
                top: 6px;
                left: 5px;
              }
            }

            .progress-value {
              font-size: 13px;
              color: #848484;
              position: absolute;
              top: 16px;
              right: 0;
              visibility: hidden;
            }
          }
        }

        span.dot {
          position: absolute;
          right: 12px;
          bottom: 12px;
          width: 9px;
          height: 9px;
          border-radius: 50%;
        }
      }

      .green {
        @extend .gray;
        background: linear-gradient(99.52deg, #00F07E -32.99%, #003827 120.45%);
      }

      .yello {
        @extend .gray;
        background: linear-gradient(99.52deg, #fcff2b -32.99%, #181403 120.45%);
      }
    }

    .sec:nth-of-type(3n+1) {
      .dot {
        background-color: #00F37E;
      }
    }

    .sec:nth-of-type(3n+2) {
      .dot {
        background-color: #FFA800;
      }
    }

    .sec:nth-of-type(3n+3) {
      .dot {
        background-color: #B70000;
      }
    }
  }
}

.showw {
  display: block;
}
</style>
